import { render, staticRenderFns } from "./ChatbotModalConfirmReplyFb.vue?vue&type=template&id=7630715e&scoped=true&"
import script from "./ChatbotModalConfirmReplyFb.vue?vue&type=script&lang=js&"
export * from "./ChatbotModalConfirmReplyFb.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotModalConfirmReplyFb.vue?vue&type=style&index=0&id=7630715e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630715e",
  null
  
)

export default component.exports